import React from 'react';

export default class ProfileForm {
	constructor(app){
		this.app = app;
		this.reset();
		this.optIn = this.optIn.bind(this);
	}

	reset(){
		this.email = '';
		this.balance = 0;
		this.password = '';
		this.confirmPassword = '';
		this.birthMonth = '';
		this.birthDay = '';
		this.birthYear = '';
		this.gender = '';
		this.race = '';
		this.educationLevel = '';
		this.householdIncome = '';
		this.marriageStatus = '';
		this.city = '';
		this.state = '';
		this.zip = '';
		this.colorBlind = '';
		this.loading = false;
		this.history = {};
		this.errorMessage = '';
		this.optInToEmailStatus = '';
		this.optInButtonClicked = false;
	}

	async optIn(){
		this.optInButtonClicked = true;
		this.app.forceUpdate();
		try{
			await this.app.http.optInToEmails();
		}catch(e){
			console.log(e);
		}

	}

	async load(){
		this.reset();
		this.app.startLoadingForm(this);
		this.username = this.app.user.username;
		try{
			const optInToEmailStatusPromise = this.app.http.getOptInToEmailsStatus();
			const userResult = await this.app.http.getUser();
			userResult.profile = userResult.profile || {};
			try{
				this.optInToEmailStatus = await optInToEmailStatusPromise;
			}catch(e){
				this.optInToEmailStatus = 'Unknown';
			}

			this.history = await this.app.http.getParticipantExperimentHistory();
			

			Object.assign(this, {...userResult.profile, balance:userResult.balance || 0});
			this.app.stopLoadingForm(this);
		}catch(e){
			this.app.stopLoadingForm(this, e);
		}
	}

	async submit(){
		this.app.startLoadingForm(this);
		try{
			let body = {
				birthMonth:      this.birthMonth,
				birthDay:        this.birthDay,
				birthYear:       this.birthYear,
				gender:          this.gender,
				race:            this.race,
				educationLevel:  this.educationLevel,
				householdIncome: this.householdIncome,
				marriageStatus:  this.marriageStatus,
				city:            this.city,
				state:           this.state,
				zip:             this.zip,
				colorBlind:      this.colorBlind,
			};

			await this.app.http.updateProfile({profile:body});
			this.app.openDialog({label:'SUCCESS', Component:() => (<div>Your profile has been saved.</div>)});

			this.app.stopLoadingForm(this);
			this.app.forceUpdate();
		}catch(e){
			this.app.stopLoadingForm(this, e);
		}
	}
}



// WEBPACK FOOTER //
// ./src/models/ProfileForm.js